// React hooks
import { useEffect } from "react";

// External libraries
import { BounceLoader } from "react-spinners";

// Project hooks and state
import { useAppDispatch, useAppSelector } from "../../services/StoreHelper";
import { update_state_value } from "../../store/reducers/AppReducer";

// Project services
import { get_agreements } from "../../services/global.services";

// Project components
import MobileUserPortal from "../../MobileComponents/MobileUserPortal/MobileUserPortal";
import Body from "./Body/Body";
import ClubDetails from "./ClubDetails/ClubDetails";

// Styles
import membership_styles from "./Body/Memberships/memberships_styles";
import user_portal_styles from "./user_portal_styles";

function UserPortal() {
  const dispatch = useAppDispatch();
  const { app_loading, app_dimensions, club } = useAppSelector(
    (state) => state.app
  );

  // 🔹 Toggle language here (or wire to Redux later)
  const { usesSpanish } = club;

  // 🔹 Inline translations (single file)
  const TEXT = {
    loading: usesSpanish ? "Cargando..." : "Loading...",
  };

  useEffect(() => {
    getAllAgreements();
  }, []);

  const getAllAgreements = () => get_agreements(dispatch, update_state_value);

  return (
    <div className={app_dimensions.desktop ? "" : "User-Portal-Mobile"}>
      {app_dimensions.desktop ? (
        <div style={user_portal_styles.user_portal}>
          {!app_loading && club.clubId ? (
            <div style={user_portal_styles.body}>
              <ClubDetails />
              <Body refresh={getAllAgreements} />
            </div>
          ) : (
            <div style={{ ...membership_styles.loader, height: "85vh" }}>
              <BounceLoader />
              <span style={{ marginTop: 12 }}>{TEXT.loading}</span>
            </div>
          )}
        </div>
      ) : (
        <MobileUserPortal />
      )}
    </div>
  );
}

export default UserPortal;